import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Renderer2, Inject, OnDestroy, NgZone, RendererStyleFlags2 } from '@angular/core';
import { AuthenticationService } from '../../../../../services/security';
import { LoginUserRequestModel } from "../../../../../shared/LoginUserRequestModel";
import { Router, ActivatedRoute } from "@angular/router"
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AppConsts } from "../../../../../shared/app-consts";
import { LoaderService } from '../../../../loader';
import { DOCUMENT } from '@angular/common';
import { EnumAuthenticateState } from '@shared/security/enum-auth-state';
import { GRecaptchaService } from '@services/grecaptcha.service';

@Component({
  selector: 'app-loginv2',
  templateUrl: './loginv2.component.html',
  styleUrls: ['./loginv2.component.css']
})
export class LoginV2Component implements OnInit ,OnDestroy {
  isLoading: boolean = false;
  returnUrl: string;
  loginForm: FormGroup;
  loginError: any = false;
  emailPattern: string = AppConsts.EMAIL_PATTERN;
  submitted: boolean = false;
  rememberMe: any = false;
  web_Url: string = AppConsts.API_URL;
  public storeUser: LoginUserRequestModel = new LoginUserRequestModel("", "", false);
  @ViewChild("divLoginPage", { static: true }) divLoginElement: ElementRef;
  submitWithCaptcha = GRecaptchaService.submitWithCaptcha;
  constructor(private route: ActivatedRoute, private service: AuthenticationService,
    private router: Router,
    public formBuilder: FormBuilder,
    private loaderService: LoaderService, private renderer: Renderer2,
    @Inject(DOCUMENT) private _document, private zone: NgZone) {
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.loaderService.hideLoader();
    GRecaptchaService.initGRecaptcha();
    let email = "";
    const rememberMe = localStorage.getItem(AppConsts.REMEMBER_ME);
    if (rememberMe && rememberMe != null && rememberMe != "")
      this.rememberMe = JSON.parse(rememberMe);

    if (this.rememberMe) {
      email = localStorage.getItem(AppConsts.USER_MAIL);
    }
    this.storeUser = new LoginUserRequestModel(email, "", this.rememberMe);
    this.buildLoginForm();
  }

  handleValidSubmit = (event) =>{
    event.preventDefault();
    this.submitWithCaptcha(this.login.bind(this),event,"submit");
  }

  get f() { return this.loginForm.controls; }

  ngAfterViewInit() {
    this.setLoginBg("#f8f9fc");
  }

  setLoginBg(color: string) {
    let pDivElement = this.divLoginElement.nativeElement.parentElement
      .parentElement.parentElement;
    let pDivElement2 = this.divLoginElement.nativeElement.parentElement
      .parentElement;
    this.renderer.setStyle(
      pDivElement,
      "background-color",
      color,
      RendererStyleFlags2.Important + RendererStyleFlags2.DashCase
    );
    this.renderer.setStyle(
      pDivElement2,
      "background-color",
      color,
      RendererStyleFlags2.Important + RendererStyleFlags2.DashCase
    );
  }


  buildLoginForm() {
    this.loginForm = this.formBuilder.group({
      Email: [
        "",
        Validators.compose([
          Validators.maxLength(100),
          Validators.pattern(this.emailPattern),
          Validators.required
        ])
      ],
      Password: [
        "",
        Validators.compose([
          Validators.minLength(8),
          Validators.required 
        ])
      ],
      RememberMe: [""]
    });

    this.loginForm.controls['Email'].valueChanges.subscribe(value => {
      this.storeUser.Email = value;
    });

    this.loginForm.controls['Password'].valueChanges.subscribe(value => {
      this.storeUser.Password = value;
    });

    this.loginForm.controls['RememberMe'].valueChanges.subscribe(value => {
      this.rememberMe = value;
    });
    this.loginForm.controls['Email'].setValue(this.storeUser.Email);
    this.loginForm.controls['RememberMe'].setValue(this.storeUser.RememberMe);
  }

  login(event: MouseEvent, recaptchaToken : string) {
    this.submitted = true;
    this.loginError = false;

    if (this.loginForm.invalid) {
      return;
    }
    this.isLoading = true;
    let user = new LoginUserRequestModel(this.storeUser.Email, btoa(this.storeUser.Password), this.storeUser.RememberMe);
    user.RecaptchaToken = recaptchaToken;
    user.IsTwoFactorRememberClient = true;
    this.service.login(user).subscribe((response: any) => {
      if (response && response != null && !response.IsError) {
        if (response.CnxEtatCompte == EnumAuthenticateState.ChgMDP) {
          const link = response.LinkResetPassword;
          this.zone.runOutsideAngular(() => {
            window.location.href = link;
          });
        }
        if (response.IsTwoFactorRequired) {
          sessionStorage.setItem(AppConsts.REMEMBER_ME, this.rememberMe);
          sessionStorage.setItem(AppConsts.DecisielCurrentEmail, this.storeUser.Email);
          this.router.navigate(['login/send-code']);
        }
        else
          this.signIn(response);
      }
      else {
        this.loginError = true;
      }
      this.isLoading = false;
    }, error => {
      this.loginError = true;
      this.isLoading = false;
    });
    return false;
  }

  signIn(response: any) {
    this.service.signIn(response, this.storeUser.Email, this.rememberMe);
    this.router.navigate(['']);
    if (this.returnUrl != 'undefined' && this.returnUrl != null && this.returnUrl.length > 0 && this.returnUrl != '/') {
      this.zone.runOutsideAngular(() => {
        window.location.href = this.returnUrl;
      });
    }
  }

  showResponse(response) {
    //call to a backend to verify against recaptcha with private key
  }

  redirectToLostPassword() {
    this.router.navigate['/lostpassword'];
  }
  ngOnDestroy() {
    this.setLoginBg("#ffffff");
  }
}
